/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesPrimary } from '../../axios/profilesPrimary'
import type {
	ProfilesPrimaryError,
	ProfilesPrimaryPathParams,
	ProfilesPrimaryResponse,
} from '../../types/ProfilesPrimary'

export const profilesPrimaryMutationKey = () => [{ url: '/:organisation/profiles/:profile/primary' }] as const

export type ProfilesPrimaryMutationKey = ReturnType<typeof profilesPrimaryMutationKey>

export type ProfilesPrimaryVariables = {
	organisation: ProfilesPrimaryPathParams['organisation']
	profile: ProfilesPrimaryPathParams['profile']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::primary */
export function useProfilesPrimary<TContext = unknown>(
	options?: UseMutationOptions<
		ProfilesPrimaryResponse,
		AxiosError<ProfilesPrimaryError>,
		ProfilesPrimaryVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: profilesPrimaryMutationKey(),
		mutationFn: ({ organisation, profile }: ProfilesPrimaryVariables) =>
			profilesPrimary(organisation, profile, config).then(res => res.data),
		...options,
	})
}
